import { colors } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem, responsiveFontSize, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import {
  EXPANDING_BUTTON__BUTTON_CLASS,
  EXPANDING_BUTTON__CONTAINER_CLASS,
} from 'src/components/molecules/ExpandableReadMoreButton';

const { spacing, fonts, text } = theme;

export const ratingSection = css`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: baseline;

  > div:first-of-type {
    margin: 0;
  }

  margin-bottom: ${pxToRem(spacing.sm)};
`;

const reviewBaseFont = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  ${responsiveFontSize(text.sm)};
`;

export const dateText = css`
  ${reviewBaseFont};
`;

export const commentText = css`
  ${reviewBaseFont};
`;

export const partnerResponseWrapper = css`
  ${reviewBaseFont};
  padding: ${pxToRem(spacing.xl)} 0 ${pxToRem(spacing.xl)};
  border-radius: ${pxToRem(10)};
  background-color: ${colors.neutralLighter};
  margin-top: ${pxToRem(spacing.lg)};
  color: ${colors.neutralDark};

  .${EXPANDING_BUTTON__CONTAINER_CLASS} {
    margin: 0 ${pxToRem(spacing.xl)} 0;

    .${EXPANDING_BUTTON__BUTTON_CLASS} {
      background-color: ${colors.neutralLighter} !important;
      margin-top: ${pxToRem(spacing.sm)} !important;

      &:before {
        background-image: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0.3),
          ${colors.neutralLighter} 60%,
          ${colors.neutralLighter} 100%
        ) !important;
      }
    }
  }
`;

export const partnerNameWrapper = css`
  ${reviewBaseFont};
  margin-left: ${pxToRem(spacing.xl)};
`;

export const partnerIcon = css`
  margin-right: ${pxToRem(8)};
  position: relative;
  top: ${pxToRem(1)};
`;

export const partnerResponseText = css`
  ${reviewBaseFont};
  color: ${colors.neutralDark};
  padding: ${pxToRem(spacing.xs)} ${pxToRem(spacing.xl)} ${pxToRem(spacing.md)};
`;
